
export function formatNumber(value, format='ru-RU', style='decimal',
                                    digits=2) {
  value = +value;
  return value.toLocaleString(format, {
      style: style,
      maximumFractionDigits: digits
  });
}


const currencyMapping = {
  'USD': '$',
  // RUB should have space after
  'RUB': ' руб.'
};

export const currencySymbol = {
  'USD': '$',
  'RUB': '₽'
};


export function formatCurrencySymbol(value) {
  return currencyMapping[value];
}


export function date(value) {
  const d = new Date(value),
    dateStr = d.toLocaleDateString();
  return `${dateStr} 
          ${d.getHours()}:${d.getMinutes()}`;
}

